import { createFileRoute } from "@tanstack/react-router";
import { TermsOfServicePage } from "../features/legal/TermsOfServicePage.tsx";

export const Route = createFileRoute("/support")({
  component: TermsOfServicePage,
});
